<div class="app-loader-backdrop" *ngIf="loading$ | async" aria-live="polite" aria-busy="true">
  <div class="app-loader" role="status" aria-label="Loading">
    <div class="app-loader__spinner"></div>
    <div class="app-loader__text">Loading…</div>
  </div>
</div>



<router-outlet></router-outlet>